<div *ngIf="loading" class="load-more__container loading-spinner mt-4">
    <div alt="Loading..." class="large progress" >
        <div class="prog1">
            <div class="prog2"></div>
        </div>
    </div>
</div>
<ng-container *ngIf="showDetails && prize">
    <div class="prize-details-component">
        <div class="prize-details-component__container">
            <div role="heading" aria-level="1" class="prize-name title-lg">{{prize.name}}</div>
            <div class="prize-description title-lg">{{prize.description}}</div>
            <ng-container *ngIf="programType == GAMETYPES.DIVISION">
                <button *ngIf="prize.availableCount != 0" [disabled]="isDisabled" class="btn btn-xl btn-secondary" 
                    [attr.aria-label]="'Redeem ' + prize.burnPoints + ' ' + (prize.burnPoints == 1 ? tokenLabelSingular : tokenLabelPlural) + ' for ' + prize.name" (click)="redeemPrize($event)">{{prize.burnPoints}} {{prize.burnPoints == 1 ? tokenLabelSingular : tokenLabelPlural}}</button>
                <button *ngIf="prize.availableCount == 0" class="prize-redeem-btn btn btn-xl btn-secondary" disabled aria-label="button">Out of Stock</button>
            </ng-container>
            <div *ngIf="prize.details" class="prize-detail body-text-xs"><span class="label">Prize Detail: </span>{{prize.details}}</div>    
            <div *ngIf="prize.disclaimer" class="prize-disclaimer body-text-xs"><span class="label">Disclaimer: </span>{{prize.disclaimer}}</div>
        </div>
        <div class="prize-details-component__image-container">
            <picture>
                <source media="(min-width: {{md}})" srcset="{{getImageUrl(prize,'desktop')}}">
                <source media="(min-width: {{sm}})" srcset="{{getImageUrl(prize,'tablet')}}">
                <img loading="lazy" class="prize-image" src="{{getImageUrl(prize,'mobile')}}" alt=""/>
            </picture>
        </div>
    </div>
    <app-prize-redeem [programName]="programName" [gameId]="gameId" [tokenLabelSingular]="tokenLabelSingular" [tokenLabelPlural]="tokenLabelPlural"></app-prize-redeem>
</ng-container>

<ng-container *ngIf="!loading && !showDetails">
    <div class="load-more__container mt-4">
        An error occured... please reload the page
    </div>
</ng-container>

<div *ngIf="!loading && noGameCode" class="load-more__container mt-4 text-center">
    The Game is no longer available
</div>

<!-- Error Modal Begins -->
<ng-template #errorPopup>
    <div class="episodic-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-tabindex="first" (click)="errorPopupRef.hide()">
            <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
        </button>
    </div>
    <div class="episodic-warning">
        <span class="svg-warning-outline"></span>
    </div>
    <div class="episodic-body pl-4 pr-4">
        <div class="title-lg-bold episodic-body__title">
            There was an issue
        </div>
        <div class="episodic-body__text">
            There was a technical issue. Please retry
        </div>
    </div>
    <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
        <button class="btn btn-xl btn-primary body-text episodic-footer__button" aria-label="Retry" data-tabindex="last"
            (click)="closeAndRefresh()">Retry</button>
    </div>
</ng-template>

<app-opt-in [userInfo]="userInfo" [singleCard]="true" [forceHideButtion]="true" [programId]="gameId"></app-opt-in>